'use client';

import type { ComponentProps } from 'react';

import { Collapsible as CollapsiblePrimitive } from '@base-ui-components/react/collapsible';

export const Collapsible = (props: ComponentProps<typeof CollapsiblePrimitive.Root>) => (
  <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />
);

export const CollapsibleTrigger = (props: ComponentProps<typeof CollapsiblePrimitive.Trigger>) => (
  <CollapsiblePrimitive.Trigger data-slot="collapsible-trigger" {...props} />
);

// Base UI calls it Panel (Radix's Content). Kept under the shadcn-familiar
// `CollapsibleContent` name for the public API. The open state is exposed on the
// trigger as `data-panel-open` (Radix's `data-state=open`) for chevron rotation etc.
export const CollapsibleContent = (props: ComponentProps<typeof CollapsiblePrimitive.Panel>) => (
  <CollapsiblePrimitive.Panel data-slot="collapsible-content" {...props} />
);
